/**
 * An array of objects that communicate the type, reason, and access of data that is used
 * Modify this array for each new application.
 * If no data is collected, the array should be empty.
 * @note This example data is from the wr-341-workshop application.
 * @type {Array<Object>}
 */
export const collectedData = [
  // ---- Structure and word your entries like the commented-out ones below ----------------
  {
    collectionType: "Full Name and Onid",
    collectionReason: "Grading",
    collectionAccess: "Instructors, Support Staff"
  },
  {
    collectionType: "Fact Sheet Submissions",
    collectionReason: "Classroom Discussion and Grading",
    collectionAccess: "Classmates, Instructors, Support Staff"
  }
];
